exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gz-carousel,gz-carousel .carousel-container{position:absolute;top:0;bottom:0;left:0;right:0}gz-carousel .visual-asset-container{display:none;height:100%;width:100%;margin-bottom:8px}gz-carousel .visual-asset-container .splash-item{max-height:100%}gz-carousel .visual-asset-container .splash-item .link{cursor:hand}gz-carousel .visual-asset-container .video{min-width:300px}gz-carousel .visual-asset-container .image{max-height:100%;max-width:100%}gz-carousel .visual-asset-container.selected{display:inherit}gz-carousel .pager{height:24px;flex-shrink:0;color:#0096d6}gz-carousel .pager .indicator-container{padding:0 4px}gz-carousel .pager .indicator-container .indicator{margin:0 6px;cursor:pointer;height:8px;width:8px;min-height:8px;min-width:8px;border-radius:100%;border:1px solid #0096d6}gz-carousel .pager .indicator-container .indicator.selected{background-color:#0096d6}gz-carousel .pager .page-selector{cursor:pointer;padding-bottom:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/carousel/carousel.scss
// module id = 100
// module chunks = 0